import {Injectable} from '@angular/core';
import {Store} from '../@core/store/store';
import {HttpService} from '../@core/http/http.service';

@Injectable({providedIn: 'root'})
export class UserStore extends Store<any> {
  constructor(protected http: HttpService) {
    super(http)
  }

  setDefaults() {
    this.setResource('user')
    this.setItemConstructor(Object)
  }
}
